import TOC from "../Module/TOC.svelte"
import VideoJs from "../Module/VideoJs.svelte"
import CookieButton from "./../Module/CookieButton.svelte"
import NewsListe from "./../Module/NewsListe.svelte"
import Placeholder from "./../Module/Placeholder.svelte"
import PositionListe from "./../Module/PositionListe.svelte"
import StandpunkteArchivListe from "./../Module/StandpunkteArchivListe.svelte"
import StandpunkteListe from "./../Module/StandpunkteListe.svelte"
import StellenangeboteListe from "./../Module/StellenangeboteListe.svelte"
import SuchErgebnisse from "./../Module/SuchErgebnisse.svelte"
import TeamListe from "./../Module/TeamListe.svelte"
import VeranstaltungenListe from "./../Module/VeranstaltungenListe.svelte"

export default {
    "mod-news": NewsListe,
    "mod-positionen": PositionListe,
    "mod-standpunkte": StandpunkteListe,
    "mod-standpunktearchiv": StandpunkteArchivListe,
    "mod-team": TeamListe,
    "mod-stellenangebote": StellenangeboteListe,
    "mod-veranstaltungen": VeranstaltungenListe,
    "mod-suchergebnisse": SuchErgebnisse,
    "mod-ccbutton": CookieButton,
    "mod-toc": TOC,
    "mod-videojs": VideoJs,
    "mod-placeholder": Placeholder,
}
